import styled, { css } from 'styled-components'

export const SC_Container = styled.div.attrs(props => ({
	className: 'container'
}))`
	position: relative;
	${props => props.textAlign ? 
	`text-align: ${props.textAlign};` 
	: null }
`

export const SC_Overflow = styled.section.attrs(props => ({
  className: 'content-section'
}))`
	${props => props.overflow ? `overflow: hidden;` : null}
`

export const SC_Section = styled.div.attrs(props => ({
  	className: 'content-section-child'
}))`
	${props => props.background ? `background: `+ (props.theme[props.background] ? props.theme[props.background] : props.background)+';' : null}
	${props => props.color ? `color: `+ (props.theme[props.color] ? props.theme[props.color] : props.color)+';' : null}
	position: relative;
	padding-top: ${props => props.padding && props.padding.top ? props.padding.top : props.theme.spacers[6]};
	padding-bottom: ${props => props.padding && props.padding.bottom ? props.padding.bottom : props.theme.spacers[6]};

	${props => props.angle ? `
	&:after {
		display: ${props => props.hasContent ? 'block' : 'none'};
		content: '';
		position: absolute;
		z-index: -1;
		left: 0;
		right: 0;
		border-style: solid;
		border-color: transparent;
		border-width: 0 100vw 0 0;
	}
	` : null }

	${props => props.angle == 'bottom' ? `
	margin-bottom: ${props.pageTemplate == 'home' ? '200px' : '100px'};

	&:after {
		border-top-width: 100px;
		border-top-color: ${props.theme[props.background] ? props.theme[props.background] : props.background};
		bottom: -100px;
	}
	` : null }

	${props => props.angle == 'top' ? `
	margin-top: 100px;

	&:after {
		border-bottom-width: 100px;
		border-bottom-color: ${props.theme[props.background] ? props.theme[props.background] : props.background};
		top: -100px;
	}
	` : null }
`

export const SC_Row = styled.div.attrs(props => ({
  className: "row",
}))`

`

export const SC_Column = styled.div.attrs(props => ({
  className: "col",
}))`
	${props => props.textAlign ? 
	`text-align: ${props.textAlign};` 
	: null }

	${props => props.textAlignMinLg ? `
	@media ${props.theme.breakpointsMin.lg} {
		text-align: ${props.textAlignMinLg};
	}
	` : null }
`

